var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gig-list-screen"},_vm._l((_vm.gigs),function(gig){return _c('div',{key:gig.id},[_c('a',{attrs:{"href":'/' + gig.id}},[_vm._v(_vm._s(gig.id))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }